import L from 'leaflet'
import 'leaflet-geometryutil'

export function setBoundsFromLatLng(point, radius) {
    return L.latLng(point.lat, point.lng).toBounds(radius * 1000)
}

export function setDistanceMarkers(
    layerLatLngs,
    map,
    offset,
    maxDistance,
    isRevert = false
) {
    let accumulated = L.GeometryUtil.accumulatedLengths(layerLatLngs)
    let length = accumulated[accumulated.length - 1]
    let x = 0
    let counter = Math.floor(length / offset)
    let coords = layerLatLngs
    for (let i = 1; i <= counter; ++i) {
        let distance = offset * i
        while (x < accumulated.length - 1 && accumulated[x] < distance) {
            ++x
        }

        let p1 = coords[x - 1]
        let p2 = coords[x]

        let line = L.polyline([p1, p2])
        let ratio =
            (distance - accumulated[x - 1]) /
            (accumulated[x] - accumulated[x - 1])
        let position = L.GeometryUtil.interpolateOnLine(map, line, ratio)
        let icon
        if (isRevert) {
            let revertDistanceInMeters = Math.floor(maxDistance - distance)
            let revertDistanceInKm = Number.parseFloat(
                revertDistanceInMeters / 1000
            ).toFixed(1)
            icon = L.divIcon({
                className: 'distance-icon',
                html: `${revertDistanceInKm} km`,
            })
        } else {
            let distanceInKm = Number.parseFloat(distance / 1000).toFixed(1)
            icon = L.divIcon({
                className: 'distance-icon',
                html: `${distanceInKm} km`,
            })
        }
        let marker = L.marker(position.latLng, {
            title: 'distance-marker',
            icon: icon,
        })
        marker
        map.addLayer(marker)
    }
}
export function removeDistanceMarkers(map) {
    let distanceMarkers = []
    map.eachLayer(layer => {
        if (layer.options.title === 'distance-marker') {
            distanceMarkers.push(layer)
        }
    })
    for (let marker of distanceMarkers) {
        marker.remove()
    }
}
